(() => {
  if (customElements.get('detropolis-street-faq')) return;

  class DetropolisStreetFAQ extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cleanups = [];
      this.querySelectorAll('[data-street-faq-item]').forEach(item => this.setupItem(item));
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.cleanups?.forEach(cleanup => cleanup());
      this.controller = null;
      this.cleanups = [];
    }

    setupItem(item) {
      const summary = item.querySelector('summary');
      const answer = item.querySelector('[data-street-faq-answer]');
      const inner = answer?.firstElementChild;
      if (!summary || !answer || !inner) return;
      const signal = this.controller.signal;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let animation = null;
      let expanded = item.open;

      const cancel = () => {
        if (!animation) return;
        animation.onfinish = null;
        animation.oncancel = null;
        animation.cancel();
        animation = null;
      };

      const settle = () => {
        cancel();
        item.open = expanded;
        item.dataset.expanded = String(expanded);
        answer.style.height = expanded ? 'auto' : '0px';
        answer.inert = !expanded;
      };

      const setExpanded = next => {
        const start = item.open ? answer.getBoundingClientRect().height : 0;
        cancel();
        expanded = next;
        answer.style.height = `${start}px`;
        item.open = true;
        item.dataset.expanded = String(expanded);
        answer.inert = !expanded;
        const end = expanded ? inner.getBoundingClientRect().height : 0;
        if (motion.matches || typeof answer.animate !== 'function' || Math.abs(end - start) < 1) {
          settle();
          return;
        }
        animation = answer.animate([{ height: `${start}px` }, { height: `${end}px` }], {
          duration: Math.min(260, Math.max(160, Math.abs(end - start) * 0.45)),
          easing: 'cubic-bezier(.22,.61,.36,1)',
          fill: 'both'
        });
        animation.onfinish = settle;
      };

      summary.addEventListener('click', event => {
        if (event.target.closest('a,button,input,select,textarea')) return;
        event.preventDefault();
        setExpanded(!expanded);
      }, { signal });

      answer.addEventListener('load', () => {
        if (animation) settle();
      }, { capture: true, signal });

      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
        if (!animation) return;
        const end = expanded ? inner.getBoundingClientRect().height : 0;
        const frames = animation.effect.getKeyframes();
        if (Math.abs(end - parseFloat(frames[frames.length - 1].height)) > 1) settle();
      }) : null;
      observer?.observe(inner);
      motion.addEventListener('change', () => { if (animation && motion.matches) settle(); }, { signal });
      settle();
      this.cleanups.push(() => {
        settle();
        observer?.disconnect();
        answer.style.removeProperty('height');
        answer.inert = false;
        delete item.dataset.expanded;
      });
    }
  }

  customElements.define('detropolis-street-faq', DetropolisStreetFAQ);
})();
